import { render } from "./04_Actualites.vue?vue&type=template&id=65c8fc3b&scoped=true"
import script from "./04_Actualites.vue?vue&type=script&lang=js"
export * from "./04_Actualites.vue?vue&type=script&lang=js"

import "./04_Actualites.vue?vue&type=style&index=0&id=65c8fc3b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c8fc3b"]])

export default __exports__